import { IDefineCommand } from 'core-ts-types';
import { MajorListSelectionBuilder } from './../builders/major_listselection_builder';

angular
  .module('major-explorer-data')
  .service('loadListSelectionCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand, $q: ng.IQService) => {
    return defineCommand('loadListSelectionCommand', (deferred: ng.IDeferred<any>) => {
      $q.all({
        listselections: $http.get('programpicker/student/interests'),
        interests: $http.get('programpicker/interests')
      })
        .then((result) => {
          const interests = result.interests.data;
          const listselections = result.listselections.data;
          deferred.resolve(new MajorListSelectionBuilder({ interests, listselections } as any));
        })
        .catch((error) => {
          deferred.reject(error);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_listselection_command.ts